export default __webpack_public_path__ + "/dist/images/2103522.png";